import { useState } from 'react';
import { CloseIcon } from 'components/Icons';
import DateRangePicker from '@wojtekmaj/react-daterange-picker';
import '@wojtekmaj/react-daterange-picker/dist/DateRangePicker.css';
import 'react-calendar/dist/Calendar.css';

const Filtering = ({
    filterDate,
    setFilterDate,
    addressSearch,
    setAddressSearch,
}) => {
    const [openCalendar, setOpenCalendar] = useState(false);

    return (
        <div className="filterContainer">
            <div className="addressSearch">
                <h4 className="mb-10">
                    Filter By address
                </h4>
                <div className="addressInput">
                    <input
                        type="text"
                        value={addressSearch}
                        placeholder="Search Addresses"
                        onChange={(e) => setAddressSearch(e.target.value.trim())}
                    />
                    <span
                        className="closeButton"
                        onClick={() => setAddressSearch('')}>
                        <CloseIcon />
                    </span>
                </div>
            </div>
            <div
                className="date-picker-container"
                onClick={() => setOpenCalendar(true)}
            >
                <h4
                    className="mb-10">
                    Filter By Date
                </h4>
                <DateRangePicker
                    onChange={setFilterDate}
                    value={filterDate}
                    isOpen={openCalendar}
                    onCalendarClose={() => setOpenCalendar(false)}
                    className="date-picker"
                />
            </div>
        </div>
    );
};

export default Filtering;
